.wrapper {
  position: relative;
  box-sizing: border-box;
}

.buttons-container {
  display: flex;
  gap: calc(var(--spacer) * 2);
  width: 100%;
}

.loader {
  position: absolute;
  width: 100%;
  --loader-height: calc(var(--spacer) * 4);
}

.dropdown-button-content {
  display: flex;
  align-items: center;
  margin-right: calc(var(--spacer) * -1.5);

  .dropdown-icon {
    font-size: 30px;
  }
}
